// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__I34B8","title":"styles_title__9_KDT","topRight":"styles_topRight__0ESJo"};